module.exports = __webpack_public_path__ + "static/img/charCircleDefault.04064f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/charCircleDefault.png
// module id = DSRL
// module chunks = 1